// @flow
import { createSelector } from 'reselect';
import { fromJS } from 'immutable';
import { bindable, stateIdentity } from '~/core/state/selectors';

const getConfigState = state => state.config || fromJS({});

// $FlowFixMe
export const getLoadingLocaleConfig = createSelector([getConfigState], config => config.get('loadingCountryConfig'));

const getMergedConfig = createSelector([getConfigState], config =>
    // $FlowFixMe
    config.get(
        'mergedConfig',
        fromJS({
            features: {}
        })
    )
);

export const getConfig = createSelector([getMergedConfig, (_, key) => key], (config, key) => {
    if (!key) {
        return config;
    }

    if (typeof key !== 'string') {
        throw new Error(`getConfig key parameter must be a string, received ${typeof key}`);
    }

    return config.getIn(key.split(':'));
});

export const getConfigBound = bindable(getConfig);

const combineKey = (_, key) => `features:${key}`;

export const getFeatureFlag = createSelector(stateIdentity, combineKey, getConfig);

export const getIconLocaleSuffix = createSelector([getMergedConfig], config => config.get('iconLocaleSuffix'));

// $FlowFixMe
export const getLocales = createSelector(getConfigState, config => config.get('locales'));



// WEBPACK FOOTER //
// ./src/core/state/config/selectors.js